import {
    Spinner as SpinnerShared,
    UiBlockingSpinner as UiBlockingSpinnerShared,
    SpinnerProps,
} from '@cp-shared-19/frontend-ui';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';

export const CenteredSpinner = () => (
    <ContentSection>
        <SpinnerShared ariaLabel="Even geduld, de pagina wordt geladen" center />
    </ContentSection>
);

export const Spinner = (props: SpinnerProps) => (
    <SpinnerShared ariaLabel="Even geduld, de pagina wordt geladen" {...props} />
);

export const UiBlockingSpinner: React.FC<{
    isBlocking?: boolean;
    children?: React.ReactNode;
    ariaLabel?: string;
}> = (props) => <UiBlockingSpinnerShared ariaLabel="Even geduld, de pagina wordt geladen" {...props} />;
